import type {
  MapSettingsSearchItemsResponse, MapSettingsSearchResponse,
} from '~/map/map.repository';
import { mapSettingsSearchInitialState } from './mapSettingsSearch.reducer';
import type { MapSettingsSearchState } from './mapSettingsSearch.state';

export const mapSettingsSearchSerializer = {
  jsonToState: (
    json: MapSettingsSearchResponse,
    toolStateSearchItems: MapSettingsSearchItemsResponse | undefined, // | undefined instead of optional to force the user of the function to fill in the param
  ): MapSettingsSearchState => {
    const { shouldStackItems, ...jsonRest } = json;

    return {
      ...mapSettingsSearchInitialState,
      ...jsonRest,
      shouldStackItems: shouldStackItems === undefined
        ? (toolStateSearchItems?.items?.length || 0) > 1
        : shouldStackItems,
    };
  },
  stateToJson: (state: MapSettingsSearchState): MapSettingsSearchResponse => {
    return state;
  },
};
